import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

import SvGraphics from "../../../assets/SvGraphics";
import {authenticationService} from "../../../services/AuthenticationService";
import * as Yup from "yup";
import Error from "../../../components/single_components/Error";
import IndicationRequest from "../../../components/PatientOnboard/IndicationRequest";
import CannabisUse from "../../../components/PatientOnboard/CannabisUse";
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";

const validationSchema = Yup.object().shape({
/*
    Cannabis_freq_past_year:Yup.string().matches(/^\d*$/, 'The field should have digits only').nullable(),
*/

    /*
        Smoked_cannabis:Yup.string().nullable().required('This field is mandatory'),
    */
    /*    Have_license_israel: Yup.string().when("Smoked_cannabis_cause", "Smoked_cannabis",{
            is: value => {
                console.log(value)
                return value[0] === "Medical" && value[1] === "YesPresent"
            },
            then: Yup.string().nullable().required('This field is mandatory'),
            otherwise: Yup.string().nullable()
        }),*/
})


class CannabisPatientTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 1,
        };
    }

    componentWillMount() {
        this.props.initValidation(validationSchema)
    }

    componentDidMount() {

    }

    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }
    onYesNoValueChange = (name,value) => {
        this.props.onYesNoValueChange(name,value)
    }

    onClickCheckboxes = (name) => {
        this.props.onClickCheckboxes(name)
    }

    onClickAddProducts = (func,value,index) => {
        this.props.onClickAddProducts(func,value,index)
    }



    render() {
        let {t} = this.props
        let {entry} = this.props
        let category=[
            "T3/C15","T5/C10",
            "T10/C2","T10/C10","T15/C3",
             "T5/C5","Other"]
        let categoryOptions=[]
        categoryOptions = category.map(item =>
            <option className={'option-style'} value={item}>{item}</option>)

        return (
            <div  className={'patientForm-box-container'}>

                <FormElementContainer
                    title={t('patient_boarding.Indication_for_the_request')}
                    Component={IndicationRequest}
                    rest={{
                        onValueChange:(name,value) => this.onValueChange(name,value) ,
                        entry:this.props.entry,
                        checkboxes:this.props.checkboxes,
                        t:(e) => this.props.t(e),
                        errors:this.props.errors
                    }}/>

                <FormElementContainer
                    title={t('patient_boarding.CannabisUse')}
                    Component={CannabisUse}
                    rest={{
                        onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                        onValueChange:(name,value) => this.onValueChange(name,value) ,
                        onClickCheckboxes:(name) => this.onClickCheckboxes(name),
                        onClickAddProducts:(func,value,index) => this.onClickAddProducts(func,value,index),
                        entry:this.props.entry,
                        checkboxes:this.props.checkboxes,
                        addedProducts:this.props.addedProducts,
                        categoryOptions:categoryOptions,
                        t:(e) => this.props.t(e),
                        productsList:this.props.productsList,
                        errors:this.props.errors
                    }}/>

            </div>
        );
    }
}



const CannabisPatientTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(CannabisPatientTabComposed);

export default CannabisPatientTab;

